import { logging } from './redux/logging';
export default (namespace => ({
  fatal: (...args) => dispatch => {
    const log = logging(dispatch, namespace);
    return log.fatal(...args);
  },
  error: (...args) => dispatch => {
    const log = logging(dispatch, namespace);
    return log.error(...args);
  },
  warn: (...args) => dispatch => {
    const log = logging(dispatch, namespace);
    return log.warn(...args);
  },
  info: (...args) => dispatch => {
    const log = logging(dispatch, namespace);
    return log.info(...args);
  },
  debug: (...args) => dispatch => {
    const log = logging(dispatch, namespace);
    return log.debug(...args);
  }
}));